import { useState, useEffect } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../lib/utils";
import { useNavigate, useLocation } from "react-router-dom";

// const reportsLinks = [
//   { id: "cashup", label: "Cash Up", path: "/cashup/1" },
//   { id: "daily", label: "Daily Sales", path: "/daily-sales" },
//   { id: "appointments", label: "Appointments", path: "/appointments" },
//   { id: "staff", label: "Staff Sales", path: "/staff-sales" },
//   { id: "payments", label: "Payments", path: "/payments" },
//   { id: "giftcards", label: "Gift Cards", path: "/giftcards" },
//   { id: "memberships", label: "Memberships", path: "/memberships" },
//   { id: "orders", label: "Orders", path: "/reports/orders" },
// ];

const reportsLinks = [
  // { id: "dashboard", label: "Reports Dashboard", path: "/reports/dashboard" },
  { id: "sales", label: "Sales", path: "/reports/sales" },
  // { id: "payments", label: "Payments", path: "/reports/payments" },
  // { id: "appointments", label: "Appointments", path: "/reports/appointments" },
  { id: "z-report", label: "Z-Report", path: "/reports/z-report" },
  { id: "x-report", label: "X-Report", path: "/reports/x-report" },
  { id: "sunbed-report", label: "Sunbed Report", path: "/reports/sunbed-report" },
  { id: "customer-report", label: "Customer Report", path: "/reports/customer-report" },
];

export default function ReportsSubSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeId, setActiveId] = useState("sales");
  const [isSalesMenuOpen, setIsSalesMenuOpen] = useState(false);

  // Sync activeId with current pathname
  useEffect(() => {
    const current = reportsLinks.find((link) =>
      location.pathname.startsWith(link.path)
    );

    if (current) {
      setActiveId(current.id);
      // If the "Sales" section is active, keep the submenu open
      if (current.id === "sales" || location.pathname.startsWith("/reports/sales") || location.pathname.startsWith("/reports/product-sales") || location.pathname.startsWith("/reports/service-sales")) {
        setIsSalesMenuOpen(true);
      } else {
        setIsSalesMenuOpen(false); // Ensure submenu closes for other sections
      }
    }
  }, [location.pathname]);

  const handleMainLinkClick = (item: { id: string; path: string }) => {
    // Navigate to the main section link and ensure submenu for Sales is closed for other links
    setActiveId(item.id);
    navigate(item.path);
    if (item.id !== "sales") {
      setIsSalesMenuOpen(false); // Close the Sales submenu for non-sales links
    }
  };

  const handleSubmenuItemClick = (submenuPath: string) => {
    // Keep the "Sales" section active and navigate to the submenu item
    setActiveId("sales");
    navigate(submenuPath);
  };

  return (
    <div className="relative w-full layout:w-56 layout:ml-2 layout:mt-3">
      <div className="flex flex-row layout:flex-col overflow-x-auto layout:overflow-y-auto w-full bg-white py-2 layout:py-4 border-b layout:border-none scrollbar-hide relative">
        {reportsLinks.map((item) => {
          const isActive = activeId === item.id;
          const isSales = item.id === "sales";

          return (
            <div key={item.id} className="flex flex-row layout:flex-col items-center layout:items-stretch">
              <button
                onClick={() => handleMainLinkClick(item)}
                className={cn(
                  "relative flex items-center px-4 py-2 text-[14px] layout:text-[15px] font-medium text-left transition-all duration-200 group whitespace-nowrap",
                  isActive
                    ? "text-purple-600"
                    : "text-gray-800 hover:text-purple-600"
                )}
              >
                <ChevronRight
                  className={cn(
                    "absolute left-0 w-4 h-4 opacity-0 transform transition-all duration-200 hidden layout:block",
                    isActive
                      ? "opacity-100 text-purple-600 translate-x-0"
                      : "group-hover:opacity-100 group-hover:text-purple-600 group-hover:translate-x-0"
                  )}
                />
                <span
                  className={cn(
                    "transition-all duration-200",
                    isActive ? "layout:translate-x-4" : "layout:group-hover:translate-x-4",
                    isActive && "border-b-2 border-purple-600 layout:border-none pb-1 layout:pb-0"
                  )}
                >
                  {item.label}
                </span>
              </button>

              {/* Submenu for Sales */}
              {isSales && isSalesMenuOpen && (
                <div className="flex flex-row layout:flex-col items-center layout:items-stretch layout:pl-8 layout:mt-2">
                  {[
                    { label: "Product Sales List", path: "/reports/product-sales" },
                    { label: "Service Sales List", path: "/reports/service-sales" },
                  ].map((submenuItem) => {
                    const isSubmenuActive = location.pathname === submenuItem.path;
                    return (
                      <button
                        key={submenuItem.path}
                        onClick={() => handleSubmenuItemClick(submenuItem.path)}
                        className={cn(
                          "block px-3 py-1 layout:px-4 layout:py-2 text-[12px] layout:text-sm font-medium text-left rounded-lg transition-all w-full whitespace-nowrap",
                          isSubmenuActive
                            ? "text-purple-600 bg-purple-50 font-semibold"
                            : "text-gray-700 hover:text-purple-600 hover:bg-gray-100"
                        )}
                      >
                        {submenuItem.label}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        {/* Right side fade for horizontal scroll when tabs visible (below 1030px) */}
        <div className="layout:hidden absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
      </div>
    </div>
  );
}
